export const freePalletPrice = 0;
